require('lodash');

require('./bootstrap');
require('./lookup');
require('./billing');
require('./payment-methods');
require('./authentication');
require('./highlight');

window.Vue = require('vue');

( function (a) {

    a(document).on('click', '.notification > button.close', function() {
        a(this).parent().remove();
        return false;
    });

    const csrfToken = a(document).find('meta[name=token]');

    a.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': csrfToken.attr('content')
        }
    });

    if (a('.contains-hero-image').length) {

        const circles = a('.contains-hero-image > svg circle');

        const timeouts = [ 3000, 5000, 8000 ];

        setInterval( function () {
            for (let i = 0; i < 6; i++) {
                const randomCircle = circles[ Math.floor(Math.random() * circles.length ) ];

                a(randomCircle).attr('fill', '#ffcc00');

                setTimeout( function () {
                    a(randomCircle).attr('fill', '#1d2d35');
                },  2000 + (i * 500));
            }
        }, timeouts[ Math.floor(Math.random() * timeouts.length )]);
    }

}(jQuery));

( function (a) {

    let $modals = a('.modal');
    let $modalCloses = a('.modal-overlay, .modal-close, .modal-header .close');
    let $modalButtons = a('.has-modal');

    if ($modalButtons.length > 0) {
        $modalButtons.on('click', (event) => {
            event.preventDefault();

            let target = a(event.currentTarget).data('target');
            let confirmationUrl = a(event.currentTarget).data('href');

            openModal(target, confirmationUrl);
        });
    }

    if ($modalCloses.length > 0) {
        $modalCloses.on('click', (event) => {
            event.preventDefault();

            closeModals();
        });
    }

    function openModal(target, confirmationUrl) {
        let $target = a('#' + target);

        if (typeof confirmationUrl !== "undefined") {
            $target.find('form').attr('action', confirmationUrl);
        }

        a('body').addClass('is-clipped');
        $target.addClass('is-active');
    }

    function closeModals() {
        a('body').removeClass('is-clipped');
        $modals.removeClass('is-active');
    }

    a('body').keypress( (event) => {
         if (event.which === 27) {
             closeModals();
         }
    });

}(jQuery));

( function (a) {

    a('.sidebar-navigation').show();

    let $sidebarNavigationList = a('.sidebar-navigation ul').find('li a[href="' + window.location.pathname + '"]');
    if ($sidebarNavigationList.length) {
        $sidebarNavigationList.closest('h2').addClass('sub-on');
        $sidebarNavigationList.closest('li').addClass('active');
    }

    a('.sidebar-navigation h2').click( function (event) {
        event.preventDefault();

        let isActive = a(this).parent().hasClass('sub-on');
        a('.sidebar-navigation ul li').removeClass('sub-on');

        isActive || a(this).parent().addClass('sub-on');
    });

    a('.docs-main').find('a[name]').each( function() {
        let linkTo = a('<a href="' + this.name + '"/>');

        a(this).parent().next().wrapInner(linkTo);
    });

}(jQuery));

( function (a) {

    window.showErrors = function (form, errors) {
        let results = [];
        let inputs = form.find('input[name], textarea[name], select[name]');

        inputs.each( function (_, input) {
            results.push(showErrorsForInput(a(input), errors && errors[input.name]));
        });

        return results;
    };

    window.showErrorsForInput = function (input, errors) {
        let results = [];
        let formGroup = a(input.closest('.validate'));

        if (formGroup.length) {
            resetFormGroup(formGroup);

            if (errors) {
                formGroup.addClass('error');

                for (let i = 0, len = errors.length; i < len; i++) {
                    const error = errors[i];
                    results.push(addError(input, error));
                }

                return results;
            } else {
                return formGroup.addClass('success');
            }
        }
    };

    window.resetFormGroup = function (formGroup) {
        formGroup.removeClass('error');
        formGroup.removeClass('success');

        const ref = formGroup.find('.help');

        let results = [];
        for (let i = 0, len = ref.length; i < len; i++) {
            const element = a(ref[i]);
            element.remove();
        }

        return results;
    };

    window.addError = function (element, error) {
        let block = a('<div></div>').addClass('help').addClass('invalid').html(error);

        return element.after(block);
    };

}(jQuery));

( function (a) {

    // let form;
    // let inputs;
    // let results = [];
    // let constraints = {};
    //
    // form = a('body').find('[data-form="support"]');
    //
    // if (form.length) {
    //     constraints = {
    //         issue_type: {
    //             presence: {
    //                 message: 'Tell us what you need help with.'
    //             }
    //         },
    //
    //         subject: {
    //             presence: {
    //                 message: 'Tell us in a nut shell your question, comment, or issue.'
    //             }
    //         },
    //
    //         message: {
    //             presence: {
    //                 message: 'Tell us what your question, comment, or issue is.'
    //             }
    //         },
    //
    //         email: {
    //             presence: {
    //                 message: 'We need a working email address to reply back to you.'
    //             },
    //
    //             email: {
    //                 message: 'We need a working email address to reply back to you.'
    //             }
    //         }
    //     };
    //
    //     form.on('submit', function (event) {
    //         let errors;
    //
    //         event.preventDefault();
    //
    //         errors = validate(form, constraints, {
    //             fullMessages: false
    //         });
    //
    //         showErrors(form, errors || {});
    //
    //         if (!errors) {
    //             return form.submit();
    //         }
    //     });
    //
    //     inputs = a(document).find('input, textarea, select');
    //     inputs.each( function (_, input) {
    //         results.push(a(input).on('change', function (event) {
    //             const errors = validate(form, constraints, {
    //                 fullMessages: false
    //             }) || {};
    //
    //             return showErrorsForInput(a(this), errors[this.name]);
    //         }));
    //     });
    //
    //     return results;
    // }

}(jQuery));

/**
 * Historical graphs
 */
( function (a) {

    const SHARED_GRAPH_CONFIG = {
        redraw: true,
        series: {
            lines: {
                show: true,
                lineWidth: 3
            },
            points: {
                show: true
            },
            shadowSize: 0
        },
        xaxis: {
            mode: "time",
            tickColor: "transparent",
            font: {
                size: 11,
                family: "sans-serif",
                color: "#d0d0d0"
            }
        },
        yaxis: {
            axisLabelPadding: 50,
            min: 0,
            tickColor: "transparent",
            font: {
                size: 11,
                family: "sans-serif",
                color: "#d0d0d0"
            },
            tickDecimals: 0
        },
        legend: {
            show: !1
        },
        grid: {
            backgroundColor: "#ffffff",
            borderWidth: {
                top: 0,
                right: 0,
                bottom: 1,
                left: 1
            },
            borderColor: "#d0d0d0"
        }
    };

    const requestGraphPlaceholder = a('body').find('#monthly-requests-graph');

    if (!!requestGraphPlaceholder.length) {
        a.ajax({
            url: '/account/stats',
            contentType: 'application/json',
            success: (response) => {
                MonthRequestGraph(response.data);
            },
            error: (error) => {
                hideGraphs();
                a('.graph').html('<p><h4>Currently unable to load stats graph.</h4></p>');
            }
        });

        const dataBuilder = (data) => {
            let sortedData = [];

            Object.keys(data).forEach( (key) => {
                sortedData.push([(key * 1000), data[key]])
            });

            if (sortedData.length === 0) {
                sortedData = [[ new Date().getTime(), 0 ]];
            }

            return sortedData;
        };

        const graphConfig = (type) => {
            let gridColor;

            if (type === 'requests') {
                gridColor = "#fdcd0b";
            }

            let config = SHARED_GRAPH_CONFIG;
            config.series.color = gridColor;
            config.tickColor = '#f00';

            return config;
        };

        const MonthRequestGraph = (data) => {
            const requestGraphData = [{ data: dataBuilder(data) }];

            a.plot(requestGraphPlaceholder, requestGraphData, graphConfig('requests'));
        };

        const hideGraphs = () => {
            requestGraphPlaceholder.hide();
        };
    }

}(jQuery));

( function (a) {

    const copyToClipboard = ($button, $element) => {
        const $temp = a('<input>');

        a('body').append($temp);

        $temp.val($element.val()).select();

        document.execCommand('copy');

        $temp.remove();

        $button.tooltip('show');

        setTimeout( () => {
            $button.tooltip('hide');
        }, 1000);
    };

    a('.copy-to-clipboard').on('click', (event) => copyToClipboard(
        a(event.currentTarget),
        a(event.currentTarget).closest('.field').find('input')
    ));

    a('.copy-to-clipboard').tooltip({ trigger: 'manual' });

}(jQuery));

( function (a) {

    const RESTRICTION_VALUES = ['ip', 'referrer'];

    const $restrictionForm = a('#credential-restriction-form');

    if ($restrictionForm.length > 0) {
        const $choices = $restrictionForm.find('[name="type"]');
        const $toggles = $restrictionForm.find('.restriction-toggle');

        $choices.on('click', function () {
            if (RESTRICTION_VALUES.indexOf(a(this).val()) > -1 && a(this).is(':checked')) {
                $toggles.removeClass('is-hidden');
            } else {
                $toggles.addClass('is-hidden');
            }
        });
    }

}(jQuery));

( function (a) {

    const $mobileNavigationButton = a('.navigation-bar-burger');

    if ($mobileNavigationButton.length > 0) {
        $mobileNavigationButton.on('click', function(event) {
            event.preventDefault();

            const target = a(this).data('target');
            const $target = a('#' + target);

            $target.toggleClass('is-active');
            a(this).toggleClass('is-active');
        });
    }

}(jQuery));
